import React from 'react';

export default function Button({ ...rest }) {
  return <nsemble-button {...rest} />;
}
